var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-card',{staticClass:"column",staticStyle:{"flex-wrap":"nowrap"},attrs:{"flat":"","bordered":""}},[_c('div',{staticClass:"card-title",style:({padding: _vm.paddingTitle})},[_vm._t("header")],2),_c('q-separator'),_c('div',{staticClass:"row col",staticStyle:{"align-items":"center"},style:({padding: _vm.paddingBody})},[_vm._t("body")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }